import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const CitasClientes = () => {
  const [citas, setCitas] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [editandoId, setEditandoId] = useState(null);

  useEffect(() => {
    const fetchInfoEmpresasa = async () => {
      try {
        const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/citasdashboard", {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });

        const data = await response.json();
        if (data) {
          if (editandoId === null) {
            setCitas(data);
          }
        } else {
          console.log(data)
          console.error("La estructura de la respuesta no es la esperada.");
        }
      } catch (error) {
        console.error("Error al obtener la información", error);
      }
    };

    fetchInfoEmpresasa();
    const intervalo = setInterval(fetchInfoEmpresasa, 5000);
    return () => clearInterval(intervalo);
  }, [token, editandoId]);


    const handleCompletar = async (id) => {
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/CompletarCita", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });

      const result = await response.json();
      if (response.ok) {
        Swal.fire({
              title: "Cita realizada correctamente!",
              icon: "success",
              draggable: true
            });
        setCitas(citas.filter((cita) => cita.id !== id));
      } else {
        alert("Error: " + result.error);
      }
    } catch (error) {
      console.error("Error al eliminar la cita", error);
    }
  };

  const handleEliminar = async (id) => {
    const resultado = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará la cita permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#c53030",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (resultado.isConfirmed) {
      try {
        const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/EliminarCita", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        });

        if (response.ok) {
          Swal.fire("Eliminada", "La cita fue eliminada correctamente.", "success");
          setCitas(citas.filter((cita) => cita.id !== id));
        } else {
          Swal.fire("Error", "No se pudo eliminar la cita. [N3]", "error");
        }
      } catch (error) {
        console.error("Error al eliminar la cita [N4]");
        Swal.fire("Error", "Ocurrió un error en la conexión. [N5]", "error");
      }
    }
  };

  const handleInputChange = (id, campo, valor) => {
    setCitas(citas.map(cita =>
      cita.id === id ? { ...cita, [campo]: valor } : cita
    ));
  };

  const handleGuardar = async (cita) => {
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/editarcita", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: cita.id,
          nombre: cita.Nombre,
          tipo: cita.Tipo,
          correo: cita.Correo,
          telefono: cita.Numero,
          fecha: cita.Fecha,
          hora: cita.Hora
        }),
      });

      if (response.ok)       
        Swal.fire({
              title: "Cita editada correctamente!",
              icon: "success",
              draggable: true
            }); else {
        alert("Error al editar la cita");
      }
    } catch (error) {
      console.error("Error al enviar los datos [A1]");
      alert("Error en la conexión");
    }
    setEditandoId(null);
  };


  return (
    <div style={styles.contenedor}>
      <div style={styles.cabecera}>
        <h2 style={styles.tituloCabecera}>📋 Panel de administración de citas</h2>
      <div style={styles.botonera}>
        <button style={styles.botonRegresar} onClick={() => navigate('/')}>🏠 Menú Principal</button>
        <button style={styles.botonRegresar} onClick={() => navigate('/CitasClientes')}>📆 Citas Pendientes</button>
        <button style={styles.botonRegresar} onClick={() => navigate('/citasdespues')}>👥 Citas Finalizadas</button>
        <button style={styles.botonRegresar} onClick={() => navigate('/adminseguros')}>📃 Formularios</button>
        <button style={styles.botonRegresar} onClick={() => navigate('/horariosadmin')}>🕒 Horarios</button>
        <button style={styles.botonRegresar} onClick={() => navigate('/adminblog')}>📰 Blog</button>
        <button style={styles.botonRegresar} onClick={() => navigate('/aiuda')}>⚙️ Ayuda</button>
        {/*<button style={styles.botonRegresar} onClick={() => navigate('/upload-image')}>📰 Imagenes</button>*/}
      </div>
      </div>

      <h3 style={styles.titulo}>🗓️ Citas de posibles clientes</h3>

      <div style={styles.grid}>
        {citas.map((cita) => (
          <div key={cita.id} style={styles.card}>
            {editandoId === cita.id ? (
              <>
                <input style={styles.input} value={cita.Nombre} onChange={(e) => handleInputChange(cita.id, 'Nombre', e.target.value)} />
                <input style={styles.input} value={cita.Correo} onChange={(e) => handleInputChange(cita.id, 'Correo', e.target.value)} />
                <input style={styles.input} value={cita.Numero} onChange={(e) => handleInputChange(cita.id, 'Numero', e.target.value)} />
                <input style={styles.input} value={cita.Fecha} onChange={(e) => handleInputChange(cita.id, 'Fecha', e.target.value)} />
                <input style={styles.input} value={cita.Hora} onChange={(e) => handleInputChange(cita.id, 'Hora', e.target.value)} />
                <select style={styles.input} value={cita.Tipo} onChange={(e) => handleInputChange(cita.id, 'Tipo', e.target.value)}>
                  <option value="Presencial">Presencial</option>
                  <option value="Virtual">Virtual</option>
                </select>
              </>
            ) : (
              <>
                <p><strong>👤 {cita.Nombre}</strong></p>
                <p>📧 {cita.Correo}</p>
                <p>📞 {cita.Numero}</p>
                <p>📅 {cita.Fecha} ⏰ {cita.Hora}</p>
                <p><strong>{cita.Tipo}</strong></p>
              </>
            )}


            <div style={styles.botones}>
              {editandoId === cita.id ? (
                <button style={styles.botonGuardar} onClick={() => handleGuardar(cita)}>💾 Guardar</button>
              ) : (
                <button style={styles.botonEditar} onClick={() => setEditandoId(cita.id)}>✏️ Editar</button>
              )}
              <button style={styles.botonEliminar} onClick={() => handleEliminar(cita.id)}>🗑️ Eliminar</button>
              <button style={styles.botonCompletar} onClick={() => handleCompletar(cita.id)}>✅ Completar Cita</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  contenedor: {
    padding: '40px 20px',
    fontFamily: 'Segoe UI, sans-serif',
    backgroundColor: '#eef2f7',
    minHeight: '100vh',
  },
  cabecera: {
    backgroundColor: '#102a43',
    color: 'white',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tituloCabecera: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  botonRegresar: {
    backgroundColor: '#334e68',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  titulo: {
    fontSize: '26px',
    textAlign: 'center',
    marginBottom: '30px',
    color: '#102a43',
    fontWeight: 'bold',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '30px',
  },
  card: {
    backgroundColor: '#334e68',
    color: 'white',
    padding: '25px',
    borderRadius: '16px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
  },
  input: {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '15px',
  },
  botones: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginTop: '15px',
    gap: '10px'
  },
  botonEditar: {
    backgroundColor: '#3e7cb1',
    color: 'white',
    padding: '8px 14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
  },
  botonGuardar: {
    backgroundColor: '#2f855a',
    color: 'white',
    padding: '8px 14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
  },
  botonEliminar: {
    backgroundColor: '#c53030',
    color: 'white',
    padding: '8px 14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
  },
  botonCompletar: {
    backgroundColor: '#3182ce',
    color: 'white',
    padding: '8px 14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
  },
  botonera: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '15px',
  },

};

export default CitasClientes;
